//import Components
import {ReactNode} from "react";

type props = {
  className?: string,
  children?: ReactNode | ReactNode[],
  page?: string,
  subPage?: boolean,
}

export default function PageWrapper({className = "", page, subPage = false, ...props}: props) {
  const isSubpage = subPage || (page && page?.split("-").length > 1);
  return (
    <>
      <main className={`pageWrapper ${page} ${className} ${isSubpage ? "subpage" : ""}`}>
        {props.children}
      </main>
    </>
  )
}
